import Immutable from 'immutable';
import { SET_PARENTAL_LOCK } from '../actions/parentalLock';
import { SET_AUTOPLAY } from '../actions/autoplay';
import { SET_VIDEO_COMPATIBILITY_MODE } from '../actions/videoCompatibilityMode';

const SETTINGS = 'settings';
const PARENTAL_LOCK = ['parentalLock'];
const AUTOPLAY = ['autoplay'];
const VIDEO_COMPATIBILITY_MODE = ['videoCompatibilityMode'];

const initialState = Immutable.fromJS({
    parentalLock: null,
    autoplay: true,
    videoCompatibilityMode: null,
});

export default function settings(state = initialState, action) {
    switch (action.type) {
        case SET_PARENTAL_LOCK:
            return state.setIn([PARENTAL_LOCK], action.payload);
        case SET_AUTOPLAY:
            return state.setIn([AUTOPLAY], action.payload);
        case SET_VIDEO_COMPATIBILITY_MODE:
            return state.setIn([VIDEO_COMPATIBILITY_MODE], action.payload);
        default:
            return state;
    }
}

export const parentalLockSelector = (state) => state.getIn([SETTINGS, PARENTAL_LOCK]);
export const autoPlaySelector = (state) => state.getIn([SETTINGS, AUTOPLAY], true);
export const videoCompatibilityModeSelector = (state) => state.getIn([SETTINGS, VIDEO_COMPATIBILITY_MODE]);
